import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Github = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M8 1.333a6.667 6.667 0 0 0-2.107 12.993c.333.06.455-.145.455-.322 0-.158-.006-.577-.01-1.133-1.854.402-2.245-.894-2.245-.894-.303-.77-.74-.975-.74-.975-.605-.414.046-.406.046-.406.669.048 1.02.687 1.02.687.595 1.02 1.56.725 1.941.555.06-.431.233-.725.423-.892-1.48-.168-3.036-.74-3.036-3.295 0-.727.26-1.322.686-1.788-.069-.17-.298-.847.065-1.765 0 0 .56-.179 1.833.684a6.385 6.385 0 0 1 1.67-.225 6.394 6.394 0 0 1 1.668.225c1.273-.863 1.832-.684 1.832-.684.364.918.135 1.596.066 1.765a2.57 2.57 0 0 1 .685 1.788c0 2.561-1.558 3.125-3.044 3.29.24.206.453.613.453 1.235 0 .89-.008 1.61-.008 1.828 0 .179.12.386.458.321A6.667 6.667 0 0 0 8 1.333"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Github;
